import type { Cell, Grid } from "@/lib/api";

/**
 * Grid-to-SVG arithmetic, shared by every maze drawing. Cell `(row, col)` has its centre at
 * world `(col * 0.2, row * 0.2)` with `+y` up, so row 0 is at the *bottom* of a picture and
 * the y axis flips here. Separate from the components because fast refresh wants files to
 * export one or the other.
 */

export type GridCells = Pick<Grid, "rows" | "cols"> & { cells: string[] };

/** SVG y of a row's top edge: row 0 is the bottom of the picture. */
export function rowY(grid: Pick<Grid, "rows">, row: number): number {
  return grid.rows - 1 - row;
}

export function cellCentre(grid: Pick<Grid, "rows">, cell: Cell): { x: number; y: number } {
  return { x: cell[1] + 0.5, y: rowY(grid, cell[0]) + 0.5 };
}

/** The viewBox that fits the grid with half a cell of floor around it. */
export function viewBox(grid: Pick<Grid, "rows" | "cols">): string {
  return `-0.5 -0.5 ${grid.cols + 1} ${grid.rows + 1}`;
}
